import {REPORT_NEW_FRONTLINE_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_FRONTLINE_ORDERS,
};
